export default __webpack_public_path__ + "static/media/cameliaLogo.5367acec.png";